/* PDP You May Also Like — reads the recently-viewed cookie (written by
   product-info.js via Shopify.Products.recordRecentlyViewed) and swaps the
   server-rendered random fallback cards already in the DOM for the
   shopper's own recently-viewed products, fetched through the Section
   Rendering API. Pads out to 4 with the fallback cards when there are
   fewer than 4 recently-viewed. Silently keeps the fallback cards as-is
   when there's no history, or a fetch fails — no empty-content flash. */
!(function () {
  'use strict';

  var COOKIE_NAME = 'shopify_recently_viewed';
  var MAX_ITEMS = 4;

  function readRecentlyViewedHandles() {
    var row = document.cookie.split('; ').find(function (item) {
      return item.indexOf(COOKIE_NAME + '=') === 0;
    });
    if (!row) return [];

    var raw = row.split('=')[1];
    return raw ? decodeURIComponent(raw).split(' ').filter(Boolean) : [];
  }

  customElements.get('pdp-also-like') ||
    customElements.define(
      'pdp-also-like',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-also-like-track]');
          if (!this.track) return;

          this.currentHandle = this.dataset.productHandle;
          this.targetSection = this.dataset.target || 'api-product-grid-item';

          this.showRecentlyViewed();
        }

        showRecentlyViewed() {
          var self = this;

          var handles = readRecentlyViewedHandles()
            .filter(function (handle) {
              return handle && handle !== self.currentHandle;
            })
            .slice(0, MAX_ITEMS);

          if (!handles.length) return;

          this.fetchCards(handles).then(function (cards) {
            if (cards.length) self.render(cards);
          });
        }

        fetchCards(handles) {
          var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
          var targetSection = this.targetSection;

          return Promise.all(
            handles.map(function (handle) {
              return fetch(root + 'products/' + handle + '?section_id=' + targetSection)
                .then(function (response) {
                  return response.ok ? response.text() : null;
                })
                .then(function (html) {
                  if (!html) return null;

                  var wrapper = document.createElement('div');
                  wrapper.innerHTML = html;
                  var card = wrapper.querySelector('.pdp-card');

                  return card ? {handle: handle, card: card} : null;
                })
                .catch(function () {
                  return null;
                });
            })
          ).then(function (results) {
            return results.filter(Boolean);
          });
        }

        render(cards) {
          var fragment = document.createDocumentFragment();
          var shown = {};

          cards.forEach(function (entry) {
            shown[entry.handle] = true;

            var li = document.createElement('li');
            li.className = 'pdp-also-like__item';
            li.setAttribute('data-product-handle', entry.handle);
            li.appendChild(entry.card);
            fragment.appendChild(li);
          });

          var needed = MAX_ITEMS - cards.length;

          if (needed > 0) {
            Array.from(this.track.querySelectorAll('[data-also-like-fallback-item]'))
              .filter(function (item) {
                return !shown[item.getAttribute('data-product-handle')];
              })
              .slice(0, needed)
              .forEach(function (item) {
                item.removeAttribute('hidden');
                fragment.appendChild(item);
              });
          }

          this.track.innerHTML = '';
          this.track.appendChild(fragment);

          if (window.theme && typeof window.theme.initWishlistButtons === 'function') {
            window.theme.initWishlistButtons();
          }

          this.dispatchEvent(new CustomEvent('theme:pdp-also-like:loaded', {bubbles: true}));
        }
      }
    );
})();
